import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { bool, string } from 'prop-types';
import classnames from 'classnames';
import { useEnvironmentData } from 'hooks';

const CategoryListItem = React.memo(function CategoryListItem({
    imageUrl,
    active,
    label,
    url,
}) {
    const { cdn } = useEnvironmentData();
    const placeHolderImageURL = useMemo(
        () => `${cdn.CDN_IMAGE}/placeholder.svg`,
        [cdn],
    );
    const isPlaceholderContent = useMemo(() => label === '' && url === '', [
        label,
        url,
    ]);

    const filterOptionCn = classnames('filter__option', {
        'filter__option--actif': active,
    });
    const linkCn = classnames('filter__link', {
        'filter__link--fake': isPlaceholderContent,
    });
    const labelCn = classnames(
        'filter__label filter__label--category filter__label--category--ais',
        {
            'filter__label--fake': isPlaceholderContent,
        },
    );
    const filterUrl = isPlaceholderContent ? '#' : url;

    const [imgToDisplay, setImgToDisplay] = useState(
        isPlaceholderContent || !imageUrl ? placeHolderImageURL : imageUrl,
    );

    useEffect(() => {
        setImgToDisplay(
            isPlaceholderContent || !imageUrl ? placeHolderImageURL : imageUrl,
        );
    }, [imageUrl, isPlaceholderContent]);

    const onError = useCallback(() => {
        setImgToDisplay(placeHolderImageURL);
    }, [imgToDisplay]);

    return (
        <li className={filterOptionCn}>
            <a href={filterUrl} className={linkCn} data-qa="filterLinkCta">
                {imgToDisplay && (
                    <img
                        src={imgToDisplay}
                        alt={label}
                        className="filter__img"
                        data-qa="filterProductImageElm"
                        onError={onError}
                    />
                )}
                <span className={labelCn} data-qa="filterLabelElm">
                    {label}
                </span>
            </a>
        </li>
    );
});

CategoryListItem.propTypes = {
    imageUrl: string,
    active: bool,
    label: string,
    url: string,
};

CategoryListItem.defaultProps = {
    imageUrl: undefined,
    active: false,
    label: '',
    url: '',
};

CategoryListItem.displayName = 'CategoryListItem';

export default CategoryListItem;
